const deleteEquipments = {
  toastr: 'deleted equipments',
  toastr1: 'Equipments successfully deleted'
};

export default deleteEquipments;
